import axios from "axios";
import SessionManager from "./SessionManager";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

// Created By Cursor
export function sessionIdFromStore() {
  const stored = SessionManager.getCurrentSession();
  if (Array.isArray(stored)) {
    return String(stored[0]?.session_id || "").trim();
  }
  return String(stored?.session_id || "").trim();
}

// Created By Cursor
export function supportStaffContext() {
  const staff = SessionManager.getStaffDetails() || {};
  return {
    school_code: String(SessionManager.getSchoolCode() || "").trim(),
    session_id: sessionIdFromStore(),
    staff_id: String(staff.staff_id || "").trim(),
    staff_name: String(staff.staff_name || "").trim(),
  };
}

// Created By Cursor
function explainAxiosError(error, fallback) {
  const status = error?.response?.status;
  if (status === 404) {
    return "Support chat API file is missing on the server (404). Upload postSupportChatMessage.php and related files to PiZeroApi_Beta/ver1/.";
  }
  if (status === 500) {
    return "Support chat API failed on the server (500). Check PHP error log.";
  }
  if (error?.code === "ECONNABORTED") {
    return "Support chat request timed out. Try again.";
  }
  // CORS / network often have no response object
  if (!error?.response) {
    return "Could not reach the support chat API (network or CORS). Prefer GET deploy endpoints on the server, then hard-refresh the web app.";
  }
  const data = error.response.data;
  if (data && typeof data === "object" && data.api_remark) {
    return String(data.api_remark);
  }
  return fallback;
}

// Created By Cursor — GET + query params (same pattern as other EduOKWeb APIs; avoids JSON POST CORS preflight)
async function getApi(endpoint, params, timeout = 20000) {
  try {
    const response = await axios.get(`${API_BASE()}${endpoint}`, {
      params,
      timeout,
      headers: { Accept: "application/json" },
    });
    return response?.data || {};
  } catch (error) {
    console.error("supportChatApi", endpoint, error);
    return {
      api_status: "ERROR",
      api_remark: explainAxiosError(error, "Could not reach support chat API."),
    };
  }
}

// Created By Cursor
export async function loadSupportThread() {
  const ctx = supportStaffContext();
  if (!ctx.school_code) {
    return { api_status: "ERROR", api_remark: "School code is missing. Please login again." };
  }
  if (!ctx.staff_id) {
    return { api_status: "ERROR", api_remark: "Staff id is missing. Please login again." };
  }
  return getApi("getSupportChatThread.php", ctx);
}

// Created By Cursor
export async function sendSupportMessage(message) {
  const ctx = supportStaffContext();
  if (!ctx.school_code) {
    return { api_status: "ERROR", api_remark: "School code is missing. Please login again." };
  }
  if (!ctx.staff_id) {
    return { api_status: "ERROR", api_remark: "Staff id is missing. Please login again." };
  }
  return getApi(
    "postSupportChatMessage.php",
    { ...ctx, message: String(message || "").slice(0, 2000) },
    70000
  );
}

// Created By Cursor
export async function requestSupportHuman(chatId) {
  const ctx = supportStaffContext();
  return getApi("requestSupportHuman.php", { ...ctx, chat_id: chatId || "" });
}

// Created By Cursor
export async function closeSupportChat(chatId) {
  const ctx = supportStaffContext();
  return getApi("closeSupportChat.php", { ...ctx, chat_id: chatId || "" });
}

// Created By Cursor
export async function loadSupportChatSettings() {
  return getApi("getSupportChatSettings.php", {});
}
